/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_CreatedInputs */

const en_product_created = /** @type {(inputs: Product_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product created`)
};

const es_product_created = /** @type {(inputs: Product_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto creado`)
};

/**
* | output |
* | --- |
* | "Product created" |
*
* @param {Product_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const product_created = /** @type {((inputs?: Product_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_product_created(inputs)
	return es_product_created(inputs)
});